export enum OrderTypeDto {
  BuyFund = 'BUY_FUND',
  SellFund = 'SELL_FUND',
  Switch = 'SWITCH',
  DepositDiscretionary = 'DEPOSIT_DISCRETIONARY',
  WithdrawDiscretionary = 'WITHDRAW_DISCRETIONARY',
  TransferDiscretionary = 'TRANSFER_DISCRETIONARY',
}
